import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useHiddenMenuHrefs } from '../hooks/useApplicationSetting';
import { isPathHiddenByMenuSetting } from '../config/menuHiddenRoutes';

/**
 * Redirects when the current path is listed in Application Setting menu.hiddenHrefs.
 */
const HiddenMenuRouteGuard = ({ children }) => {
  const location = useLocation();
  const { hiddenHrefs, isLoading } = useHiddenMenuHrefs();

  if (isLoading) {
    return children;
  }

  if (isPathHiddenByMenuSetting(location.pathname, hiddenHrefs)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default HiddenMenuRouteGuard;
